<template>
  <div v-if="data" class="row-box">
    <WrapperField
      :data="createDataField({
        fieldName: 'notarialWritName', 
        fieldValue: data.notarialWritName, 
        fieldGroup: 'executiveNoticesRecoveryDetails',
      })"
    ></WrapperField>

    <!-- Сведения о договоре: start -->
    <div class="form-base__title preview break">Сведения о договоре</div>
    <WrapperField
      v-for="(value, index) in data"
      :key="value + index + Math.random()"
      :data="createDataField({
        fieldName: index, 
        fieldValue: value, 
        fieldGroup: 'executiveNoticesRecoveryDetails',
        fieldGroupEdit: 'noticesRecoveryStep5',
      })"
    ></WrapperField>
    <!-- Сведения о договоре: end -->
  </div>
</template>

<script>
import { createDataField } from '@/utils/fullStatementView';
import WrapperField from '@/components/elements/statement/FullStatementView/base/WrapperField';

export default {
  name: 'Step5',
  components: {
    WrapperField,
  },
  props: ['data'],
  data: () => ({
    createDataField,
  }),
};
</script>
